import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from './';
import { Paper, TextArea } from '../common';
import {
  StyledContactFormButtonContainer,
  StyledContactFormField,
  StyledContactFormTitle,
} from '../styled/Contact.styled';

const ContactForm = (props) => {
  const {
    maxLength,
    firstName,
    lastName,
    email,
    submitForm,
    formLoading,
    formSubjects,
    body,
    setBody,
    subject,
    setSubject,
  } = props;

  return (
    <>
      <StyledContactFormTitle>
        <FormattedMessage id="contact.page.main.form.compose" />
      </StyledContactFormTitle>

      <Paper style={{ marginBottom: '1rem' }}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submitForm();
          }}
        >
          <StyledContactFormField title={email} sameLine>
            <label>
              <FormattedMessage  id="contact.page.main.form.sender" />
            </label>
            <>&nbsp;</>
            <span>
              {firstName} {lastName}
            </span>
          </StyledContactFormField>

          {formSubjects && formSubjects.length > 0 && (
            <StyledContactFormField>
              <label htmlFor="formSubject">
                <FormattedMessage id="contact.page.main.form.reference" />
              </label>

              <select
                name="subject"
                id="formSubject"
                className="select-sm select-primary u3-mb-2"
                onChange={(e) => setSubject(e.target.value)}
                value={subject}
              >
                {formSubjects.map((subject) => (
                  <option key={subject} value={subject}>
                    {subject}
                  </option>
                ))}
              </select>
            </StyledContactFormField>
          )}

          <StyledContactFormField>
            <label>
              <FormattedMessage id="contact.page.main.form.message" />
            </label>

            <TextArea
              style={{ marginBottom: '1rem' }}
              name="1"
              id="23"
              cols="30"
              rows="8"
              className="input-primary input-sm u3-mb-2"
              maxLength={maxLength}
              onChange={(e) => setBody(e.target.value)}
              value={body}
              required
            />
          </StyledContactFormField>

          <StyledContactFormButtonContainer >
            <Button type="submit"  disabled={formLoading}>
              <FormattedMessage id="contact.page.main.form.send" />
            </Button>
          </StyledContactFormButtonContainer>
        </form>
      </Paper>
    </>
  );
};

ContactForm.propTypes = {
  body: PropTypes.string.isRequired,
  setBody: PropTypes.func.isRequired,
  subject: PropTypes.string.isRequired,
  setSubject: PropTypes.func.isRequired,
  maxLength: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  submitForm: PropTypes.func,
  formLoading: PropTypes.bool,
  formSubjects: PropTypes.array,
};

export default ContactForm;
